var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 41,
    viewBox: "0 0 55 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6152 25.2828L13.3151 25.2919L13.3243 24.5828H12.6152C6.03467 24.5828 0.7 19.2468 0.7 12.666C0.7 6.08281 6.03476 0.746875 12.6152 0.746875C19.2006 0.746875 24.5351 6.08298 24.5351 12.666C24.5351 18.2089 21.1888 29.313 12.5403 38.7755C12.0656 39.269 11.3338 39.479 10.6398 39.2607L10.6376 39.26C9.67669 38.9613 9.13106 37.9542 9.39504 36.9908C11.3068 33.5881 12.2868 30.6946 12.7887 28.6356C13.0414 27.5993 13.1728 26.7749 13.2412 26.2038C13.2753 25.9183 13.2938 25.6961 13.3037 25.5424C13.3086 25.4655 13.3114 25.4058 13.313 25.3638C13.3138 25.3429 13.3143 25.3263 13.3146 25.3143L13.315 25.2997L13.3151 25.2949L13.3151 25.2932L13.3151 25.2925C13.3151 25.2922 13.3151 25.2919 12.6152 25.2828Z",
    stroke: "#864FFD",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4423 25.2828L42.1422 25.2919L42.1515 24.5828H41.4423C34.8618 24.5828 29.5271 19.2468 29.5271 12.666C29.5271 6.08291 34.8619 0.746875 41.4423 0.746875C48.0277 0.746875 53.3623 6.08299 53.3623 12.666C53.3623 18.2089 50.016 29.313 41.3673 38.7756C40.8928 39.269 40.1609 39.479 39.4669 39.2607L39.4647 39.26C38.5039 38.9613 37.9582 37.9542 38.2222 36.9908C40.134 33.5881 41.1139 30.6946 41.6159 28.6356C41.8685 27.5993 42 26.7749 42.0683 26.2038C42.1025 25.9183 42.1209 25.6961 42.1308 25.5424C42.1358 25.4655 42.1386 25.4058 42.1402 25.3638C42.141 25.3429 42.1415 25.3263 42.1418 25.3143L42.1421 25.2997L42.1422 25.2949L42.1422 25.2932L42.1422 25.2925C42.1422 25.2922 42.1422 25.2919 41.4423 25.2828Z",
    stroke: "#864FFD",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingQuote);
export default __webpack_public_path__ + "static/media/landing-quote.971825ddd4f3c2fd0a89bf48cd3ed718.svg";
export { ForwardRef as ReactComponent };